import React, { useEffect, useState } from 'react';

import styles from './Floater.module.scss';

const Floater = props => {
    const {x, y, className = '', style = {}, children, onTransitionEnd} = props,
        [delays] = useState({
            HorizontalDelay: _.random(0, -20, true),
            HorizontalDuration: _.random(15, 30, true),
            VerticalDelay: _.random(0, -20, true),
            VerticalDuration: _.random(15, 30, true),
            appearDelay: _.random(.25, 5, true),
        }),
        containerStyle = {
            ...style,
            transform: `translate(${x}px, ${y}px)`,
            // animationDuration: delays.appearDelay + 's',
            transitionDelay: delays.appearDelay + 's',
        },
        verticalMovementStyle = {
            animationDelay: delays.HorizontalDelay + 's',
            animationDuration: delays.HorizontalDuration + 's',
        },
        horizontalMovementStyle = {
            animationDelay: delays.VerticalDelay + 's',
            animationDuration: delays.VerticalDuration + 's',
        };

    return (
        <div className={[styles.Floater, className].join(' ')} style={containerStyle} onTransitionEnd={onTransitionEnd}>
            <div className={styles.verticalMovement} style={verticalMovementStyle}>
                <div className={styles.horizontalMovement} style={horizontalMovementStyle}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Floater;
